const updateRatingElements = () => {
  const ratingElements = document.querySelectorAll(".sr-only");
  
  if (ratingElements.length > 0) {
    ratingElements.forEach(ratingElement => {
      const ratingText = ratingElement.textContent;
      const ratingNumber = ratingText.match(/(\d+(\.\d+)?)/)[0];
      ratingElement.textContent = `${ratingNumber} / 5.0`;
    });
  } else {
    // Retry until the elements are found
    setTimeout(updateRatingElements, 1000); // Check every 1000ms
  }
}

const displayYotpoElements = () => {
  const yotpoElements = document.querySelectorAll('.yotpo.bottomLine');
  if (typeof yotpo !== 'undefined' && yotpoElements.length > 0 && document.readyState === 'complete') {
    updateRatingElements();
  } else {
    // Retry until the elements are found
    setTimeout(displayYotpoElements, 500); // Check every 500ms
  }
};

window.addEventListener('PandectesEvent_OnConsent', function(event) {
  if ((event.detail.preferences & 1) === 0) {
    setTimeout(displayYotpoElements(), 500);
  }
});

if (typeof usf !== 'undefined') {
  usf.event.add('init', () => {
    if (localStorage.getItem('userConsent') === 'true') {
      setTimeout(displayYotpoElements(), 500);
    }
  });
} else {
  // Retry until usf is defined
  setTimeout(() => {
  }, 500);
}